import { render, staticRenderFns } from "./inspectionCategoryForm.vue?vue&type=template&id=53e0de36"
import script from "./inspectionCategoryForm.vue?vue&type=script&lang=js"
export * from "./inspectionCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports